import { jsx } from "react/jsx-runtime";
import { Tooltip as Tooltip$1 } from "@mui/material";
import { spreadSx } from "../../utils/spreadSx.js";
import { useAutoHideWhenMoved } from "./useAutoHideWhenMoved.js";
import { inheritDataTestId } from "../../utils/dataTestId.js";
const popperModifiers = {
  popper: {
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, -6]
        }
      }
    ]
  }
}, Tooltip = (props) => {
  const {
    className,
    title,
    disabled,
    sx,
    arrowSx,
    size = "xs",
    componentsProps,
    children,
    ...restProps
  } = props, { onOpen, onClose, ref, opened } = useAutoHideWhenMoved(disabled);
  return disabled ? props.children : /* @__PURE__ */ jsx(
    Tooltip$1,
    {
      ref,
      onOpen,
      onClose,
      open: opened,
      enterTouchDelay: 0,
      leaveTouchDelay: 5e3,
      title,
      slotProps: popperModifiers,
      componentsProps: {
        tooltip: {
          "data-test-id": inheritDataTestId(restProps),
          sx: [styles.tooltip, stylesTooltipBySize[size], ...spreadSx(sx)]
        },
        arrow: {
          sx: [styles.arrow, ...spreadSx(arrowSx)]
        },
        ...componentsProps
      },
      placement: "left",
      arrow: !0,
      enterDelay: 500,
      disableInteractive: !0,
      ...restProps,
      classes: { popper: className, ...props.classes },
      children
    },
    opened === !1 ? 1 : 0
  );
}, styles = {
  tooltip: (t) => ({
    backgroundColor: t.palette.tooltip.bg,
    color: t.palette.tooltip.content,
    padding: "6px 12px!important",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 500,
    boxShadow: t.boxShadows.dragAndDrop,
    maxWidth: 200,
    "*": {
      color: t.palette.tooltip.content
    }
  }),
  arrow: (t) => ({
    color: t.palette.tooltip.bg
  })
}, stylesTooltipBySize = {
  xxs: {
    maxWidth: 150
  },
  xs: {
    maxWidth: 200
  },
  sm: {
    maxWidth: 240
  },
  md: {
    maxWidth: 300
  },
  lg: {
    maxWidth: 360
  },
  xl: {}
};
export {
  Tooltip
};
//# sourceMappingURL=Tooltip.js.map
